import { HTTP } from "../../../http-common";
import { getField, updateField } from "vuex-map-fields";
import { httpError } from "../../../models/httpError";
import { Summary } from "../../../models/summary";
import { SmsMessage } from "@/models/SmsMessage";
const state = {
  summary: new Summary(),
  message: new httpError(),
  reportView: null,
  orderStatus: 0
};

//getters

const getters = {
  getField
};

//Mutations
const mutations = {
  setSummary(state, summary) {
    state.summary = summary;
    state.message = new httpError();
  },
  setProgress(state, message) {
    state.message = message;
  },
  setReportView(state, orderView) {
    state.reportView = orderView;
  },
  updateField
};

//ACTIONS
const actions = {
  resetSummary({ commit }) {
    commit("setSummary", new Summary());
  },

  sendSMS({ dispatch, commit }, sms) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await HTTP.post("Order/SendSMS", new SmsMessage(sms));
        if (response.status == 200) {
          if (response.data.map(x => x.status == "sent").includes(true)) {
            commit("orders/setOrderStatus", 1, {
              root: true
            });
            dispatch(
              "setMessage",
              new httpError({
                message: "SMS sent OK",
                httpStatus: 200
              })
            );
            resolve(response.data.status);
          }
        }
      } catch (err) {
        dispatch(
          "setMessage",
          new httpError({
            message: "SMS not sent:" + err.message,
            httpStatus: 500
          })
        );
        reject();
      }
    });
  },
  sendEmail({ commit, dispatch, rootGetters }, emailOptions) {
    return new Promise((resolve, reject) => {
      emailOptions.orderID = rootGetters["orders/orderID"];
      commit("setSummary", emailOptions);

      let credCheck = "false";
      if (
        process.env.NODE_ENV !== "production" &&
        this.state.orders.isResidential
      )
        credCheck = "true";
      HTTP.post(
        emailOptions.anonymous
          ? "Order/SendFromCustomerEmail/"
          : `Docusign/SendRequest/` + credCheck,
        emailOptions
      )
        .then(data => {
          if (data.status === 200) {
            dispatch(
              "setMessage",
              new httpError({
                message: "sent successfully",
                httpStatus: 200
              })
            );
            commit("orders/setOrderStatus", 1, {
              root: true
            });
            commit("orders/setOrderEnvelope", data.data.envelopeId, {
              root: true
            });
            resolve(data.data);
          }
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Error" + err.message,
              httpStatus: 500
            })
          );
          reject(err.message);
        });
    });
  },
  getSigningUrl({ dispatch }, envelopeID) {
    return new Promise((resolve, reject) => {
      HTTP.post("Docusign/GetSigningURL", {
        envelopeID
      })
        .then(data => {
          if (data.status === 200) {
            window.location.href = data.data.uri;
          }
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Error" + err.message,
              httpStatus: 500
            })
          );
          reject(err);
        });
    });
  },
  populateSummaryPDF({ state, dispatch }, data) {
    return new Promise((resolve, reject) => {
      if (typeof data == "undefined" && state.reportView == null) {
        reject("no data available");
        return;
      }
      let request = {
        template: {
          name: "OrderReport",
          recipe: data == "pdf" ? "chrome-pdf" : "phantom-image",
          engine: "handlebars",
          waitForJS: true
        },
        data: state.reportView
      };

      HTTP.post("Report/Generate", request, { responseType: "arraybuffer" })
        .then(res => {
          let blob = new Blob([res.data], {
            type: data == "pdf" ? "application/pdf" : "image/png"
          });

          resolve(blob);
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Error" + err.message,
              httpStatus: 500
            })
          );
          reject(err);
        });
    });
  },
  populateGrenke({ dispatch, rootState }) {
    return new Promise((resolve, reject) => {
      HTTP.post("Grenke/GrenkeFinancePDF", rootState.orders.rows[0].orderID)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Error" + err.message,
              httpStatus: 500
            })
          );

          reject(err);
        });
    });
  },
  populateSummary({ commit, dispatch, rootState }, orderID) {
    return new Promise((resolve, reject) => {
      var url = "Order/OrderReport/";

      var response = HTTP.get(url + orderID); //, {responseType: 'document'});
      response
        .then(function(data) {
          if (data.status === 200) {
            commit("orders/setOrder", data.data.order, {
              root: true
            });
            commit("setReportView", data.data);
            dispatch("orders/uploads/populateUploads", orderID, {
              root: true
            });
            resolve(data.data);
          } else reject(data);
        })
        .catch(function(err) {
          dispatch(
            "setMessage",
            new httpError({
              message: "Error" + err.message,
              httpStatus: 500
            })
          );

          reject(err);
        });
    });
  },

  setMessage({ commit }, message) {
    return new Promise(resolve => {
      commit("setProgress", message);
      if (message.httpStatus == 200)
        setTimeout(() => {
          commit("setProgress", new httpError());
          resolve();
        }, 2000);
      resolve();
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
